module.exports = __webpack_public_path__ + "img/back_width.7289c2f8.png";